import { render, staticRenderFns } from "./AreaDetails.vue?vue&type=template&id=51534cc0"
import script from "./AreaDetails.vue?vue&type=script&lang=js"
export * from "./AreaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports